// extracted by mini-css-extract-plugin
module.exports = {"section":"footer-module--section--mm3aH","wrapper":"footer-module--wrapper--L9Ajd","logo":"footer-module--logo--29W55"};